<template>
  <form class="form2">
    <div class="form-group row">
      <label for="form-name" class="col-sm-5 col-form-label"
        >Your Full Name*</label
      >
      <div class="col-sm-7">
        <input
          type="text"
          class="form-control"
          :class="{ 'is-invalid': nameStatus }"
          id="form-name"
          v-model.trim="form.name"
          @keyup="inputValidHandler('name')"
          required
        />
        <div class="invalid-feedback">
          Please provide a valid name.
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="form-email" class="col-sm-5 col-form-label"
        >Your Email address*</label
      >
      <div class="col-sm-7">
        <input
          type="email"
          class="form-control"
          :class="{ 'is-invalid': emailStatus }"
          id="form-email"
          v-model.trim="form.email"
          @keyup="inputValidHandler('email')"
          required
        />
        <div class="invalid-feedback">
          Please provide a valid email.
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="form-jobTitle" class="col-sm-5 col-form-label"
        >Your Job Title*</label
      >
      <div class="col-sm-7">
        <input
          type="text"
          class="form-control"
          :class="{ 'is-invalid': jobStatus }"
          id="form-jobTitle"
          v-model.trim="form.job"
          @keyup="inputValidHandler('job')"
          required
        />
        <div class="invalid-feedback">
          Please provide a valid job.
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="form-company" class="col-sm-5 col-form-label"
        >Your Company*</label
      >
      <div class="col-sm-7">
        <input
          type="text"
          class="form-control"
          :class="{ 'is-invalid': companyStatus }"
          id="form-company"
          v-model.trim="form.company"
          @keyup="inputValidHandler('company')"
          required
        />
        <div class="invalid-feedback">
          Please provide a valid company.
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="form-country" class="col-sm-5 col-form-label"
        >Your Country*</label
      >
      <div class="col-sm-7">
        <select
          class="form-control"
          :class="{ 'is-invalid': countryStatus }"
          id="form-country"
          v-model="form.country"
          @change="countryChangeHandler"
          required
        >
          <option v-for="(value, key) in numCountry" :key="key" :value="key">{{
            key
          }}</option>
        </select>
        <div class="invalid-feedback">
          Please select a valid country.
        </div>
      </div>
    </div>
    <div class="form-group row justify-content-center form-btn">
      <div class="col-sm-auto">
        <button
          class="btn btn-primary"
          @click.prevent="submitHandler"
          :disabled="btnDisable"
        >
          <div
            class="spinner-border spinner-border-sm"
            :class="btnDisable ? '' : 'd-none'"
            role="status"
            aria-hidden="true"
          ></div>
          Contact FiveStones
        </button>
      </div>
    </div>
    <SubmitMessage :status="msgStatus" :message="msg" />
  </form>
</template>

<script>
import SubmitMessage from '../components/SubmitMessage'

export default {
  name: 'ContactForm',
  components: { SubmitMessage },
  props: {
    form: { type: Object, required: true },
    numCountry: { type: Object, required: true }
  },
  data() {
    return {
      nameStatus: false,
      emailStatus: false,
      jobStatus: false,
      companyStatus: false,
      countryStatus: false,
      contactFsOffice: {
        Australia: 'FiveStones AU',
        'New Zealand': 'FiveStones NZ',
        'Hong Kong': 'FiveStones HK',
        China: 'FiveStones CN',
        Taiwan: 'FiveStones TW',
        Singapore: 'FiveStones SG',
        Indonesia: 'FiveStones ID',
        'South Korea': 'FiveStones KR',
        Philippines: 'FiveStones PH',
        Thailand: 'FiveStones TH',
        Other: 'FiveStones HK'
      },
      msg: '',
      msgStatus: false,
      btnDisable: false,
      sheetAPI:
        'https://script.google.com/macros/s/AKfycbwxO8bCFElmsdbZMF4ri5gZDpQlIDPTyoMa-6St0iMMl-PNVsl8dt7ZjxwJiT2k0g/exec'
      // 'https://script.google.com/macros/s/AKfycbxL_SXgM6VPCfwxy8GNEHr0GHDWEVeEzkaDJB4edkbDis66SJQ6K0DlzeVd1RzVsVWywA/exec'
    }
  },
  methods: {
    countryChangeHandler() {
      this.inputValidHandler('country')
      this.$emit('budgetSaved')
      this.form['contact-fs-office'] = this.contactFsOffice[this.form.country]
    },
    async submitHandler() {
      // btnDisable, msgStatus, msg
      this.submitStatusChangeHandler(true, '', '')
      let formValid = this.formValidHandler()
      // console.log(formValid)
      if (!formValid) {
        this.submitStatusChangeHandler(
          false,
          'error',
          'One or more fields have an error. Please check and try it again.'
        )
      } else {
        try {
          let res = await this.formResponse()
          // console.log(res)
          this.submitStatusChangeHandler(
            false,
            'success',
            'Thank you for your message. It has been sent.'
          )
          this.distopryData()
          this.formDatalayerPush()
        } catch (err) {
          console.error(err)
          this.submitStatusChangeHandler(
            false,
            'error',
            'Please wait a minute and try it again.'
          )
        }
      }
    },
    submitStatusChangeHandler(btnDisable, msgStatus, msg) {
      this.btnDisable = btnDisable
      this.msgStatus = msgStatus
      this.msg = msg
    },
    formValidHandler() {
      for (let x in this.form) {
        this.inputValidHandler(x)
      }
      return (
        !this.nameStatus &&
        !this.emailStatus &&
        !this.jobStatus &&
        !this.companyStatus &&
        !this.countryStatus
      )
    },
    inputValidHandler(name) {
      if (name === 'email') {
        var reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return !reg.test(this.form[name])
          ? (this[`${name}Status`] = true)
          : (this[`${name}Status`] = false)
      } else {
        return !this.form[name]
          ? (this[`${name}Status`] = true)
          : (this[`${name}Status`] = false)
      }
    },
    formResponse() {
      let submitData = this.submitDataHandler()
      let body = this.encoded(submitData)
      console.log(body)
      let api = this.sheetAPI
      return this.$http.post(api, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    },
    submitDataHandler() {
      const {
        formName,
        name,
        email,
        job,
        company,
        numOfSizes,
        numOfFrames,
        numOfVariations,
        budgetSaved,
        hoursSaved
      } = this.form
      let date = this.getDate()
      let contactFsOffice = this.form['contact-fs-office']
      let allCreativeFieldPair = this.allCreativeFieldPair()
      return {
        formName,
        date,
        name,
        email,
        job,
        company,
        'all-creative-field-pair': allCreativeFieldPair,
        'contact-fs-office': contactFsOffice,
        numOfSizes,
        numOfFrames,
        numOfVariations,
        budgetSaved,
        hoursSaved
      }
    },
    getDate() {
      let time = new Date()
      let YYYY = time.getFullYear()
      let MM = time.getMonth() + 1
      let DD = time.getDate()
      let hh = time.getHours()
      let mm = time.getMinutes()
      let ss = time.getSeconds()
      return `${YYYY}/${MM}/${DD} ${hh}:${mm}:${ss}`
    },
    allCreativeFieldPair() {
      const roiData = JSON.parse(localStorage.getItem('calculateROI'))
      if (roiData) {
        let all = []
        roiData
          .filter(x => {
            let now = Math.floor(new Date().getTime() / 1000)
            let last30Min = now - 1800
            return x.timestamp > last30Min
          })
          .sort((a, b) => {
            return a.timestamp - b.timestamp
          })
          .slice(-5)
          .forEach(x => {
            all.push([x.numOfSizes, x.numOfFrames, x.numOfVariations])
          })
        console.log(all)
        return all
      } else {
        return []
      }
    },
    encoded(formData) {
      return Object.keys(formData)
        .map(x => {
          return encodeURIComponent(x) + '=' + encodeURIComponent(formData[x])
        })
        .join('&')
    },
    distopryData() {
      return localStorage.removeItem('calculateROI')
    },
    formDatalayerPush() {
      let vm = this
      this.$gtm.trackEvent({
        event: 'contactFsDdcCal',
        details: {
          country: vm.form['contact-fs-office']
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ContactForm.vue